import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';


const AuthBackground = () => {
  const backgroundImages = [
    {
      src: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&h=600&fit=crop",
      alt: "Concert crowd with stage lights"
    },
    {
      src: "https://images.pexels.com/photos/1190298/pexels-photo-1190298.jpeg?w=800&h=600&fit=crop",
      alt: "Business conference presentation"
    },
    {
      src: "https://images.pixabay.com/photo/2016/11/23/15/48/audience-1853662_960_720.jpg?w=800&h=600&fit=crop",
      alt: "Theater audience applauding"
    }
  ];

  return (
    <div className="hidden lg:block lg:w-1/2 relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <Image
          src={backgroundImages?.[0]?.src}
          alt={backgroundImages?.[0]?.alt}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-primary/80 via-primary/60 to-primary/40"></div>
      </div>
      {/* Content Overlay */}
      <div className="relative z-10 flex flex-col justify-center h-full p-12 text-white">
        <div className="max-w-md">
          <h2 className="text-4xl font-bold mb-6 leading-tight">
            Discover Amazing Events Near You
          </h2>
          <p className="text-xl mb-8 text-white/90 leading-relaxed">
            Join thousands of event enthusiasts who trust EventGrid to find and book their next unforgettable experience.
          </p>

          {/* Feature List */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="flex items-center justify-center w-8 h-8 bg-white/20 rounded-full">
                <Icon name="Search" size={16} />
              </div>
              <span className="text-white/90">Smart event discovery</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="flex items-center justify-center w-8 h-8 bg-white/20 rounded-full">
                <Icon name="CreditCard" size={16} />
              </div>
              <span className="text-white/90">Secure booking &amp; payments</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="flex items-center justify-center w-8 h-8 bg-white/20 rounded-full">
                <Icon name="QrCode" size={16} />
              </div>
              <span className="text-white/90">Digital tickets &amp; QR codes</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="flex items-center justify-center w-8 h-8 bg-white/20 rounded-full">
                <Icon name="BarChart3" size={16} />
              </div>
              <span className="text-white/90">Host analytics dashboard</span>
            </div>
          </div>

          {/* Stats */}
          <div className="mt-12 grid grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-2xl font-bold">50K+</div>
              <div className="text-sm text-white/80">Events Hosted</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold">2M+</div>
              <div className="text-sm text-white/80">Tickets Sold</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold">98%</div>
              <div className="text-sm text-white/80">Satisfaction</div>
            </div>
          </div>
        </div>
      </div>
      {/* Decorative Elements */}
      <div className="absolute top-20 right-20 w-32 h-32 bg-white/10 rounded-full blur-xl"></div>
      <div className="absolute bottom-20 left-20 w-24 h-24 bg-white/10 rounded-full blur-xl"></div>
    </div>
  );
};

export default AuthBackground;